import { Category } from '@/lib/types/interfaces/Category';
import { City } from '@/lib/types/interfaces/City';
import { Nullable } from '@/lib/types/Nullable';

export const generateSearchMessage = (
  currentCategory: Nullable<Category>,
  location: Nullable<City>,
  term: Nullable<string>,
) => {
  if (currentCategory && location) {
    return {
      title: `${currentCategory.name} CRE Services in ${location.name}, ${location.state}`,
      description: `Find top ${currentCategory.name} service providers in ${location.name}, ${location.state} to support your next project`,
    };
  }

  if (currentCategory) {
    return {
      title: `${currentCategory.name} CRE Services`,
      description: `Find top ${currentCategory.name} services providers in your area to support your next project`,
    };
  }

  if (location) {
    return {
      title: `Commercial Real Estate Services in ${location.name}, ${location.state}`,
      description: `Find top Commercial Real Estate service providers in ${location.name}, ${location.state} to support your next project`,
    };
  }

  if (term) {
    return {
      title: `Search Results for ${term}`,
      description: 'Find top Commercial Real Estate services providers in your area to support your next project',
    };
  }

  return {
    title: 'Commercial Real Estate Services',
    description: 'Find top Commercial Real Estate services providers in your area to support your next project',
  };
};

export const generateServiceMessage = (categories: Category[] | undefined, path: string, subCategories: Category[] | undefined) => {
  const pathItems = path.split('/');
  let stateIndex: null | number = null;
  let location: null | string = null;
  const currentCategory = categories?.find(category => pathItems.includes(category.slug)) || null;
  pathItems.some((item, index) => {
    const isState = item.length === 2;
    if (isState) {
      stateIndex = index;
    }
    return isState;
  });
  const subcategory = subCategories?.find(item => {
    if (pathItems.includes(item.slug)) return item;
    return null;
  });
  if (stateIndex && pathItems[stateIndex + 1]) {
    location = `${pathItems[stateIndex + 1].replace('_', ' ')}, ${pathItems[stateIndex]}`;
  }

  if (subcategory && location) {
    return {
      title: `${subcategory.name} CRE Services in ${location}`,
      description: `Find top ${subcategory.name} service providers in ${location} to support your next project`,
    };
  }

  if (subcategory) {
    return {
      title: `${subcategory?.name} CRE Services`,
      description: `Find top ${subcategory?.name} service providers in your area to support your next project`,
    };
  }

  if (currentCategory && location) {
    return {
      title: `${currentCategory.name} CRE Services in ${location}`,
      description: `Find top ${currentCategory.name} service providers in ${location} to support your next project`,
    };
  }
  if (location) {
    return {
      title: `Commercial Real Estate Services in ${location}`,
      description: `Find top Commercial Real Estate service providers in ${location} to support your next project`,
    };
  }
  if (currentCategory) {
    return {
      title: `${currentCategory.name} CRE Services`,
      description: `Find top ${currentCategory.name} services providers in your area to support your next project`,
    };
  }
  return {
    title: 'Commercial Real Estate Services',
    description: 'Find top Commercial Real Estate services providers in your area to support your next project',
  };
};
